module.exports = __webpack_public_path__ + "static/media/post.f6ee61a7.png";